import { Button, ButtonType } from "@constellation-academy/epic-ui";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ValidatedField } from "@components/ValidatedField";
import { SelectUserField } from "@features/users/select-user-field";
import { useTranslation } from "@i18n/hooks";
import { inputFieldClass } from "./select-single-user-form.styles";
import {
	SelectSingleUserFormProps,
	SelectSingleUserFormState,
} from "./select-single-user-form.types";

export const SelectSingleUserForm = ({
	onUserSelected,
	disabled,
	accountId,
}: SelectSingleUserFormProps) => {
	const { t } = useTranslation("common");
	const formik = useFormik<SelectSingleUserFormState>({
		initialValues: {},
		isInitialValid: false,
		validateOnChange: false,
		validateOnBlur: false,
		validationSchema: Yup.object().shape({
			userId: Yup.string().min(1).required(t("user.oneRequired")),
		}),
		onSubmit: (data, { setSubmitting }) => {
			onUserSelected(data.userId!);
			setSubmitting(false);
		},
	});

	return (
		<form onSubmit={formik.handleSubmit} className="w-12 p-fluid mb-5">
			<ValidatedField<SelectSingleUserFormState, string>
				className={inputFieldClass}
				name={"userId"}
				label={t("user.selectUser")}
				formikConfig={formik}
				component={(renderConfig) => (
					<SelectUserField accountId={accountId} {...renderConfig} />
				)}
			/>

			<Button
				disabled={!formik.isValid || disabled}
				label={t("user.addUser")}
				type={ButtonType.Submit}
			/>
		</form>
	);
};
